import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestLicenseCertificate} from "../Api";
import {errorToast, successToast} from "../helper/ToastHelper";
import {adminKeys} from "../QueryKeys";
import {saveByteArray, toIsoString} from "../Utils";

type DownloadCertificateProps = {
  username: string;
  name: string;
  level: string;
  uniband: boolean;
};

const DownloadLicenseCertificate = (props: DownloadCertificateProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const today: string = toIsoString(new Date()).slice(0, 10);

  const downloadResults = useMutation(()=>
    requestLicenseCertificate(props.username, props.level, props.uniband), {
    onSuccess: (TData) => {
      successToast(toast, "Descargando constancia");
      saveByteArray(props.name+"-"+today, TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando constancia");
    },
  });

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}/>

        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar constancia</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadResults.mutate()}
              >
                Descargar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadLicenseCertificate;
